<template>
	<div>
		<div class="auth-section">
			<div class="auth-block auth-block-left">
				<div class="auth-form-container">
					<form
						action=""
						class="auth-form"
						@submit.prevent="signFromIin"
					>
						<div class="auth-top">
							<div>
								<img
									class="auth-form-logo"
									src="../assets/logo-picture.png"
									alt=""
								/>
							</div>
							<div>
								<h1 class="auth-form-project-title">
									КазМунайГаз
								</h1>
								<p class="auth-form-project-description">
									Вход в личный кабинет
								</p>
							</div>
						</div>
						<div class="input-container">
							<i class="material-icons">account_circle</i>
							<input
								class="login-input-field"
								type="text"
								placeholder="Введите ИИН"
								v-model="username"
								name="iin"
							/>
						</div>
						<div class="input-container">
							<i class="material-icons">lock</i>
							<input
								class="login-input-field"
								type="password"
								placeholder="Введите пароль"
								v-model="password"
								name="password"
							/>
						</div>

						<button class="auth-btn">Войти</button>
						<button
							class="auth-btn edc"
							type="button"
							@click="showEcpModal"
						>
							Войти через ЭЦП
						</button>
						<button
							class="auth-btn"
							type="button"
							@click="showRegistrationModal"
						>
							Регистрация
						</button>
					</form>
				</div>
			</div>
			<div class="auth-block auth-block-right">
				<div class="instruction-block">
					<iframe width="560" height="315" src="https://www.youtube.com/embed/HVmztq6ADmY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					<a :href="downloadInstruction" download>
						<button class="downloadBtn instructionBtn">
							Скачать инструкцию по металлолому
						</button>
					</a>
					<a :href="downloadInstructionTmz" download>
						<button class="downloadBtn instructionBtn">
							Скачать инструкцию ТМЗ
						</button>
					</a>
				</div>
				<div class="contact-item-email">
					<i class="custom-icon fas fa-envelope"></i>
					<ul>
						<li>
							<a
								class="mail-link"
							>
                Ay.Sagynzhanova@kmg.kz
							</a>
						</li>
						<li>
							<a
								class="mail-link"
							>
                azatbekov@prodev.kz
							</a>
						</li>
<!--						<li>-->
<!--							<a-->
<!--								class="mail-link"-->
<!--							>-->
<!--								sultan.ryspekov@internet.ru-->
<!--							</a>-->
<!--						</li>-->
						<!-- <li>
							<a
								href="mailto:bagdatov@prodev.kz"
								class="mail-link"
							>
								bagdatov@prodev.kz
							</a>
						</li> -->

					</ul>
				</div>
				<div class="contact-item-phone">
					<ul>
						<li>+7 7172 78 67 79</li>
<!--						<li>+7 7172 95 97 39</li>-->
<!--						<li>+7 702 999 65 50</li>-->
						<!-- <li>+7 700 789 78 33</li> -->

					</ul>
					<i class="custom-icon fas fa-phone"></i>
				</div>
			</div>
		</div>

		<!-- Registration modal -->
		<modal name="registration-modal">
			<div class="modal-inner">
				<div>
					Для оформления заявки на регистрацию новых пользователей
					портала, скачайте, заполните шаблон и отправьте на почту
					<address>Ay.Sagynzhanova@kmg.kz</address>
				</div>
				<a :href="downloadRegistraionTemplate" download>
					<button class="downloadBtn">Скачать шаблон</button>
				</a>
			</div>
		</modal>

		<!-- Digital Signature modal -->
		<modal name="ds-modal">
			<div class="modal-inner">
				<h3>Вход через ЭЦП</h3>
				<form
					method="POST"
					id="auth-form"
					@submit.prevent="sendSignData"
				>
					<div hidden>
						<select id="storageSelect">
							<option value="PKCS12" selected>PKCS12</option>
						</select>
					</div>

					<p>
						Для успешной авторизации рекомендуется
						<br />
						выбирать ключ
						<b>GOSTKNCA</b>
					</p>
					<br />
					<div hidden>
						<input id="keyId_sign" name="keyId_sign" type="text" />
						<input id="subjectDn_sign" name="subjectDn_sign" />
						<input
							id="serialNumber_sign"
							name="serialNumber_sign"
						/>
						<input
							id="certNotAfter_sign"
							name="certNotAfter_sign"
						/>
						<input
							id="certNotBefore_sign"
							name="certNotBefore_sign"
						/>
						<textarea
							id="pem_sign"
							name="pem_sign"
							rows="7"
							readonly
						></textarea>
						<input id="alias_sign" name="alias_sign" />
						<input id="algorithm_sign" name="algorithm_sign" />
						<input id="subjectCn_sign" name="subjectCn_sign" />
						<input id="issuerCn_sign" name="issuerCn_sign" />
						<input id="issuerDn_sign" name="issuerDn_sign" />
						<input
							id="authorityKeyIdentifier_sign"
							name="authorityKeyIdentifier_sign"
						/>
					</div>
					<button
						class="auth-choose-cert"
						type="button"
						@click="getKeyInfoCall"
					>
						Выбрать сертификат
					</button>
					<button id="auth_sign" type="submit" hidden>submit</button>
				</form>
			</div>
		</modal>
	</div>
</template>

<script async>
import { getKeyInfo } from '@/nclayer/ncalayer';

export default {
	data() {
		return {
			username: '',
			password: '',
			showModal: false,
			showECPLogin: false,
			showRegModal: false,
			downloadRegistraionTemplate: `${process.env.VUE_APP_MEDIA_URL}/media/registrationTemplate.xlsx`,
			downloadInstruction: `${process.env.VUE_APP_MEDIA_URL}/media/Инструкция_Металл.pdf`,
			downloadInstructionTmz: `${process.env.VUE_APP_MEDIA_URL}/media/Инструкция_ТМЗ.pdf`,
		};
	},
	methods: {
		showRegistrationModal() {
			this.$modal.show('registration-modal');
		},
		showEcpModal() {
			this.$modal.show('ds-modal');
		},
		getKeyInfoCall() {
			let selectedStorage = 'PKCS12';
			getKeyInfo(selectedStorage);
		},
		sendSignData() {
			let keyId_sign = document.getElementById('keyId_sign');
			let subjectDn_sign = document.getElementById('subjectDn_sign');
			let serialNumber_sign = document.getElementById(
				'serialNumber_sign'
			);
			let certNotAfter_sign = document.getElementById(
				'certNotAfter_sign'
			);
			let certNotBefore_sign = document.getElementById(
				'certNotBefore_sign'
			);
			let pem_sign = document.getElementById('pem_sign');
			let alias_sign = document.getElementById('alias_sign');
			let algorithm_sign = document.getElementById('algorithm_sign');
			let subjectCn_sign = document.getElementById('subjectCn_sign');
			let issuerCn_sign = document.getElementById('issuerCn_sign');
			let issuerDn_sign = document.getElementById('issuerDn_sign');
			let authorityKeyIdentifier_sign = document.getElementById(
				'authorityKeyIdentifier_sign'
			);
			let formData = {
				alias_sign: alias_sign.value,
				keyId_sign: keyId_sign.value,
				algorithm_sign: algorithm_sign.value,
				subjectCn_sign: subjectCn_sign.value,
				subjectDn_sign: subjectDn_sign.value,
				issuerCn_sign: issuerCn_sign.value,
				issuerDn_sign: issuerDn_sign.value,
				serialNumber_sign: serialNumber_sign.value,
				certNotAfter_sign: certNotAfter_sign.value,
				certNotBefore_sign: certNotBefore_sign.value,
				authorityKeyIdentifier_sign: authorityKeyIdentifier_sign.value,
				pem_sign: pem_sign.value,
			};
			this.$store.dispatch('login', formData);
		},
		signFromIin({ dispatch }) {
			let formData = {
				username: this.username,
				password: this.password,
			};
			this.$store
				.dispatch('loginWithIin', formData)

				.then(response => {
					this.$router.push({ name: 'home' });
					this.$store.dispatch('addNotification', {
						type: 'success',
						message: 'Успешная авторизация',
					});
				}).catch(e => {
          this.$store.dispatch('addNotification', {
            type: 'error',
            message: e.response.data.message,
        });
          console.log(e)
      });
		},
	},
};
</script>

<style scoped>
.modal-inner {
	height: 100%;
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	text-align: center;
}

.modal-inner address {
	font-weight: bold;
}

.auth-section {
	display: grid;
	grid-template-columns: 1fr 1fr;
}

@media screen and (max-width: 1100px) {
	.auth-section {
		grid-template-columns: 1fr;
	}
}

.auth-block {
	height: 100vh;
}

.mail-link {
	color: white;
	text-decoration: none;
	user-select: text;
}

.auth-block-right {
	height: 100vh;
	background-image: url('../assets/back.png'),
		linear-gradient(rgba(54, 66, 158, 0.9), rgba(54, 66, 158, 0.9));
	background-blend-mode: overlay;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}

.instruction-block {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.auth-form-container {
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.auth-form {
	display: flex;
	flex-direction: column;
	max-width: 26.25rem;
}

.auth-form-logo {
	width: 110px;
	display: inline;
}

.auth-top {
	display: grid;
	grid-template-columns: 0.3fr 1fr;
	margin-bottom: 30px;
}

.auth-form-project-title {
	display: inline;
	vertical-align: top;
	color: #36429e;
	font-size: 2.7rem;
	font-family: Arial, Helvetica, sans-serif;
	font-weight: 900;
	line-height: 58px;
	letter-spacing: -3px;
}

.auth-form-project-description {
	width: 100%;
	text-align: center;
	font-size: 25px;
}

.auth-input {
	width: 420px;
	padding: 1.5rem 1rem;
}

.input-container {
	display: flex;
	width: 100%;
}

.material-icons {
	padding: 0.9rem;
	min-width: 50px;
	text-align: center;
	font-size: 1.8rem;
}

.login-input-field {
	width: 100%;
	padding: 10px;
	border: none;
	outline: none;
	margin: 0.5rem 0 1rem;
	border-radius: 10px;
}

.auth-btn {
	background: #36429e;
	padding: 1rem;
	border: none;
	outline: none;
	color: white;
	border-radius: 10px;
	margin-bottom: 0.8rem;
	cursor: pointer;
}

.auth-btn.edc {
	background: #454757;
}

.downloadBtn {
	margin-top: 1rem;
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
	background: #7ad38d;
	color: white;
}

.downloadBtn.instructionBtn {
	background: #fff;
	color: #36429e;
}

.contact-item-phone {
	margin-bottom: 24px;
	font-size: 16px;
	color: #322;
	display: flex;
	gap: 1rem;
	position: absolute;
	bottom: 0;
	right: 0;
}

.contact-item-phone ul {
	list-style-type: none;
	color: #fff;
	font-size: 1.2rem;
	user-select: text;
}

.contact-item-email {
	margin-bottom: 24px;
	font-size: 16px;
	color: #322;
	display: flex;
	gap: 1rem;
	position: absolute;
	bottom: 0;
	left: 0;
	padding-left: 1rem;
}

.contact-item-email ul {
	list-style-type: none;
	color: #fff;
	font-size: 1.2rem;
}

.custom-icon {
	width: 60px;
	height: 60px;
	line-height: 60px;
	background-color: #fff;
	text-align: center;
	color: #3494db;
	border-radius: 50%;
	margin-right: 16px;
}
</style>
